import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["objectType", "objectId"];
import ErrorBoundary from 'customer-data-objects-ui-components/ErrorBoundary';
/*  @ts-expect-error Jun-5-2024, 11:9UTC FixMe: Complete Migration to TypeScript  */
import ObjectTypesType from 'customer-data-objects-ui-components/propTypes/ObjectTypesType';
/*  @ts-expect-error Jun-5-2024, 11:9UTC FixMe: Complete Migration to TypeScript  */
import SidebarCardError from 'customer-data-sidebar/SidebarCardError';
import { Query } from '@apollo/client/react/components';
/*  @ts-expect-error Jun-5-2024, 11:9UTC FixMe: Complete Migration to TypeScript  */
import { getAlternateDataState } from 'customer-data-sidebar/graphQL/getAlternateDataState';
import PropTypes from 'prop-types';

/*  @ts-expect-error Jun-5-2024, 11:9UTC FixMe: Complete Migration to TypeScript  */
import { jsx as _jsx } from "react/jsx-runtime";
export function getDefaultQueryVariables({
  objectType,
  subjectId
}) {
  return {
    objectType,
    subjectId: parseInt(subjectId, 10)
  };
}
export const withUniversalSidebarCardQuery = ( /*  @ts-expect-error Jun-5-2024, 11:9UTC FixMe: Complete Migration to TypeScript  */
Component, /*  @ts-expect-error Jun-5-2024, 11:9UTC FixMe: Complete Migration to TypeScript  */
{
  gqlConfig,
  key: cardKey
}) => {
  if (!gqlConfig) {
    return Component;
  }

  /*  @ts-expect-error Jun-5-2024, 11:9UTC FixMe: Complete Migration to TypeScript  */
  const CardQuery = props => {
    const {
      parse,
      query,
      getGraphQLQueryVariables = getDefaultQueryVariables
    } = gqlConfig;
    const {
        objectType,
        objectId
      } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);
    if (!objectId || !objectType || !query) return null;
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      ErrorComponent: SidebarCardError,
      boundaryName: "GraphQLCardQuery_SidebarError",
      children: /*#__PURE__*/_jsx(Query, {
        variables: getGraphQLQueryVariables(props),
        query: query,
        partialRefetch: true,
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
        children: ({
          loading,
          error,
          data,
          fetchMore,
          networkStatus
        }) => {
          const loadingOrError = getAlternateDataState({
            loading,
            error,
            data,
            networkStatus
          }, cardKey);
          if (loadingOrError) {
            return loadingOrError;
          }
          let loadedData;
          if (!loading || Object.keys(data || {}).length !== 0) {
            loadedData = parse(objectType, data);
          }
          return /*#__PURE__*/_jsx(Component, Object.assign({
            objectType: objectType,
            objectId: objectId,
            subjectId: objectId
          }, rest, loadedData, {
            isLoaded: !loading,
            fetchMore: fetchMore
          }));
        }
      })
    });
  };
  CardQuery.propTypes = {
    objectId: PropTypes.string.isRequired,
    objectType: ObjectTypesType.isRequired
  };
  return CardQuery;
};